import mediator from "@tvg/mediator";
import { RaceProgram } from "@tvg/ts-types/Race";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";

export const betButtonClickEvent = ({
  option,
  module,
  currentRace,
  betTypeCode
}: {
  option: string;
  module: string;
  currentRace: RaceProgram;
  betTypeCode: WagerTypeCodesEnum | undefined;
}) => {
  mediator.base.dispatch({
    type: "PP_RUNNER_SELECTION",
    payload: {
      option,
      currentRace,
      betTypeCode,
      module
    }
  });
};

export const PickSelectRunnerEvent = ({
  race,
  betType,
  column
}: {
  race: RaceProgram;
  betType: string;
  column?: number;
}) => {
  mediator.base.dispatch({
    type: "PPM_TVG5_RUNNER_SELECTION",
    payload: {
      label:
        column !== undefined ? `Pick L${column + 1}` : "Pick Single Runner",
      race,
      betType
    }
  });
};
